import { render, staticRenderFns } from "./ViewBtn.vue?vue&type=template&id=0ee86790"
import script from "./ViewBtn.vue?vue&type=script&lang=ts"
export * from "./ViewBtn.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports